import React, {useState} from 'react';
import styled from 'styled-components';
import {labels} from '../../util/uiconstants';
import {EngagementStatus, EngagementReasonType} from '../../util/enumerations';
import env from '../../util/env';
import ModalControl from '@ey/modal-control';
import {SVGICONS} from '@ey/icons';
import {useDispatch} from 'react-redux';
import {
	DeleteEngagement,
	PatchEngagement
} from '../../actions/engagementsaction';
import FormField from '@ey/motif-react-wrapper/FormField';
import Label from '@ey/motif-react-wrapper/Label';
import RadioButton from '@ey/motif-react-wrapper/RadioButton';
import RadioButtonGroup from '@ey/motif-react-wrapper/RadioButtonGroup';
import TextLink from '@ey/motif-react-wrapper/TextLink';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import _ from 'lodash';
import {adobeAnalytics} from '@ey/voltron-analytics';
import {clickActionArgs} from '../Common/Adobe Analytics/actionHelpers.js';
import {
	eventTypes,
	controlTypes,
	clickActionNames,
	locationInPages
} from '../Common/Adobe Analytics/constants.js';

const EngagementDeleteModal = (props) => {
	const dispatch = useDispatch();

	const {show, id, hide, quit, refreshDashboard} = props;
	const {engagementstatus, workspacecountryid, activeusercount, isldcupgraded} =
		props.data;

	const [badTryNoReasonEntered, setBadTryNoReasonEntered] = useState(false);
	const [badTryNoCommentReasonEntered, setBadTryNoCommentReasonEntered] =
		useState(false);
	const [isActing, setIsActing] = useState(false);
	const [deleteCommentText, setDeleteCommentText] = useState(undefined);
	const [deleteReasonTypeID, setDeleteReasonTypeID] = useState(0);
	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

	let canDeleteMsg = labels.deleteengagementconfirmationmessage;

	const getDeleteActiveUserCount = () => {
		let itemEngagementStatus = engagementstatus;
		let count = 1;
		if (
			!(
				itemEngagementStatus === EngagementStatus.GAMXMigrationError ||
				itemEngagementStatus === EngagementStatus.RollForwardError ||
				itemEngagementStatus === EngagementStatus.RestoreError ||
				itemEngagementStatus === EngagementStatus.ImportError ||
				itemEngagementStatus === EngagementStatus.ImportTemplateError
			)
		) {
			count = activeusercount;
		}

		return count;
	};

	const deleteActiveUserCount = getDeleteActiveUserCount();

	const OKtitle =
		deleteActiveUserCount == 1 ? labels.confirmlabel : labels.submitlabel;
	if (deleteActiveUserCount == 1) {
		canDeleteMsg = labels.deleteengagementconfirmationmessageoneuser;
	}

	const applyClass =
		badTryNoCommentReasonEntered || badTryNoReasonEntered ? 'red' : '';

	const handleDeleteConfirm = async () => {
		if (_.isEmpty(deleteReasonTypeID) || parseInt(deleteReasonTypeID) === 0) {
			setBadTryNoReasonEntered(true);
			return;
		}

		if (
			parseInt(deleteReasonTypeID) === EngagementReasonType.Other &&
			_.isEmpty(deleteCommentText)
		) {
			setBadTryNoCommentReasonEntered(true);
			return;
		}

		setIsActing(true);

		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				clickActionNames.deleteEngagementConfirm,
				controlTypes.button,
				locationInPages.deleteEngagementModal
			)
		);

		try {
			if (engagementstatus === EngagementStatus.ExternalReviewEngagement) {
				await dispatch(
					DeleteEngagement(
						env.getURL('serviceUrl') + '/engagements.json/' + id,
						null
					)
				);
			} else {
				await dispatch(
					PatchEngagement(
						env.getURL('serviceUrl') + '/engagements.json/' + id,
						JSON.stringify(modelDelete())
					)
				);
			}
		} finally {
			await refreshDashboard();
			closeModal();
		}
	};

	const modelDelete = () => {
		return {
			id: id,
			data: {
				countryid: workspacecountryid,
				engagementstatusid:
					getDeleteActiveUserCount() > 1
						? EngagementStatus.MarkedForDeletion
						: EngagementStatus.Deleted,
				deleteinitiatorcomments:
					deleteReasonTypeID == EngagementReasonType.Other
						? deleteCommentText
						: null,
				ispatchfromuniversal: true,
				deleteReasonTypeID: deleteReasonTypeID
			}
		};
	};

	const closeModal = () => {
		setBadTryNoReasonEntered(false);
		setBadTryNoCommentReasonEntered(false);
		setDeleteCommentText(undefined);
		setDeleteReasonTypeID(0);
		hide();
	};

	const cancelModal = () => {
		setBadTryNoReasonEntered(false);
		setBadTryNoCommentReasonEntered(false);
		setDeleteCommentText(undefined);
		setDeleteReasonTypeID(0);
		quit();
	};

	const handleDeleteCommentChange = (event) => {
		let text = event.target.value;

		if (text.trimLeft().length <= 4000) {
			setDeleteCommentText(text.trimLeft());
			setBadTryNoCommentReasonEntered(false);
		} else {
			event.target.value = deleteCommentText;
		}
	};

	const handleRationalRadioButtonChange = (event) => {
		setDeleteReasonTypeID(event.target.value);
		setBadTryNoReasonEntered(false);
	};

	const onHide = () => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				clickActionNames.deleteEngagementCancel,
				controlTypes.button,
				locationInPages.deleteEngagementModal
			)
		);
		cancelModal();
	};

	return (
		<div>
			{isActing ? (
				<section className="loader-wrapper">
					<LoadingIndicator show fullscreen />
				</section>
			) : (
				<ModalControl
					title={labels.deleteengagement}
					modalsize="small"
					onOkClick={() => {
						handleDeleteConfirm();
					}}
					confirmBtnTitle={OKtitle}
					closeTitle={labels.close}
					closeBtnTitle={labels.cancel}
					onHide={onHide}
					show={show}
					backdrop="static"
					focusTrapActive={false}
				>
					<DeleteEngagementStyle>
						<div id="message" className="delmsg-header">
							<span className="del-msg">{canDeleteMsg}</span>
							<section className="del-msgdescp">
								<span className="del-msg1">
									{labels.deleteengagementconfirmationmessageoneuser1}
									<TextLink
										variant="alt"
										href={env.getDocArcDocumentationUrl()}
										target="_blank"
									>
										{labels.deleteengagementconfirmationmessageoneuser2}
									</TextLink>
								</span>
								<span className="del-msg1">
									{labels.deleteengagementconfirmationmessageoneuser3}
								</span>
							</section>
						</div>
						<section className="deleng-radiogrp">
							<FormField>
								<Label>{labels.deleteengagementreasonquestion}</Label>
								<RadioButtonGroup>
									<RadioButton
										name="trainingengagement"
										id="trainingengagement"
										value={EngagementReasonType.TrainingEngagement.toString()}
										key={EngagementReasonType.TrainingEngagement}
										checked={
											deleteReasonTypeID ==
											EngagementReasonType.TrainingEngagement
										}
										onChange={handleRationalRadioButtonChange}
									>
										{labels.deletereasontrainingengagementlabel}
									</RadioButton>
									<RadioButton
										name="restoredorcopied"
										id="restoredorcopied"
										value={EngagementReasonType.RestoredOrCopiedEngagement.toString()}
										key={EngagementReasonType.RestoredOrCopiedEngagement}
										checked={
											deleteReasonTypeID ==
											EngagementReasonType.RestoredOrCopiedEngagement
										}
										onChange={handleRationalRadioButtonChange}
									>
										{labels.deletereasonrestoredorcopiedlabel}
									</RadioButton>
									<RadioButton
										name="createdbymistake"
										id="createdbymistake"
										value={EngagementReasonType.CreatedByMistake.toString()}
										key={EngagementReasonType.CreatedByMistake}
										checked={
											deleteReasonTypeID ==
											EngagementReasonType.CreatedByMistake
										}
										onChange={handleRationalRadioButtonChange}
									>
										{labels.deletereasoncreatedbymistakelabel}
									</RadioButton>

									<RadioButton
										name="terminedbyclient"
										id="terminedbyclient"
										value={EngagementReasonType.TerminatedByClient.toString()}
										key={EngagementReasonType.TerminatedByClient}
										checked={
											deleteReasonTypeID ==
											EngagementReasonType.TerminatedByClient
										}
										onChange={handleRationalRadioButtonChange}
									>
										{labels.deletereasonterminedbyclientlabel}
									</RadioButton>
									<RadioButton
										name="other"
										id="other"
										value={EngagementReasonType.Other.toString()}
										key={EngagementReasonType.Other}
										checked={deleteReasonTypeID == EngagementReasonType.Other}
										onChange={handleRationalRadioButtonChange}
									>
										{labels.deletereasonotherlabel}
									</RadioButton>
								</RadioButtonGroup>
							</FormField>
						</section>
						{deleteReasonTypeID == EngagementReasonType.Other && (
							<section className="commentwrapper">
								<textarea
									placeholder={labels.deleteengagementreasonlabel}
									onChange={handleDeleteCommentChange}
									className={applyClass}
									value={deleteCommentText}
								/>
								{badTryNoCommentReasonEntered && (
									<section className="submit-error">
										<section>
											<SVGICONS styleName="small" id="icon" name="error" />
											<span>{labels.deleteengagementreasonrequired}</span>
										</section>
									</section>
								)}
							</section>
						)}

						{badTryNoReasonEntered && (
							<section className="commentwrapper">
								<section className="submit-error">
									<section>
										<SVGICONS styleName="small" id="icon" name="error" />
										<span>{labels.deleteengagementcommentreasonrequired}</span>
									</section>
								</section>
							</section>
						)}
					</DeleteEngagementStyle>
				</ModalControl>
			)}
		</div>
	);
};

export default EngagementDeleteModal;

const DeleteEngagementStyle = styled.section`
	padding: var(--px-20) 0;
	.delmsg-header {
		line-height: normal;
		font-size: var(--px-14);
		.del-msg {
			font-weight: bold;
		}
		.del-msgdescp {
			margin-top: var(--px-26);
			.del-msg1 {
				font-size: var(--px-14);
			}
		}
	}
	.deleng-radiogrp {
		margin-top: var(--px-40);
		.motif-form-field {
			margin-bottom: 0;
		}
		.motif-label {
			width: 100%;
			margin-bottom: var(--px-15);
		}
		.motif-radio-button-group {
			svg {
				width: var(--px-13);
				height: var(--px-13);
				min-width: var(--px-13);
				min-height: var(--px-13);
				//margin-top: calc(var(--px-3) * -1);
			}
		}
	}
	& .commentwrapper {
		margin-top: var(--px-30);
		textarea {
			font-size: var(--px-14);
			background: var(--neutrals-100);
			border: none;
			border-bottom: var(--px-1) solid var(--neutrals-700);
			display: block;
			height: var(--px-120);
			width: 100%;
			max-width: 100%;
			margin-bottom: var(--px-10);
			resize: none;
			padding: var(--px-10);
			line-height: var(--px-17);
			&::placeholder {
				margin-left: var(--px-10);
			}
			&:hover:not(:disabled) {
				background: var(--neutrals-200);
			}
			&:focus:not(:disabled) {
				background: var(--neutrals-200);
				border-bottom-width: var(--px-2);
			}
			&.red {
				border-bottom: var(--px-1) solid var(--red-600);
			}
		}

		& .submit-error {
			font-size: var(--px-12);
			line-height: normal;
			height: var(--px-20);
			padding-bottom: var(--px-20);
			color: var(--red-600);

			& svg {
				fill: var(--red-600);
				vertical-align: text-bottom;
				margin-right: var(--px-5);
			}
		}
	}
`;
